var _title, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "All")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,75.74V67.2h5.66V49.94H40V41.35H54.31V67.11H60v8.62H40Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.64,24.26A5.75,5.75,0,0,1,54.35,30a5.89,5.89,0,0,1-5.9,5.79A5.76,5.76,0,0,1,42.85,30,5.87,5.87,0,0,1,48.64,24.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.16,0c27.45,0.09,50,22.66,49.84,49.92A50.14,50.14,0,0,1,49.8,100C22.33,100.05-.13,77.31,0,49.56A50,50,0,0,1,50.16,0Zm0.23,9.46A40.42,40.42,0,0,0,9.58,49.91C9.33,72,27.66,90.44,49.81,90.49a40.48,40.48,0,0,0,40.57-40.7C90.25,27.64,72.25,9.49,50.39,9.46Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.64c1babb.svg";
export { ForwardRef as ReactComponent };